interface Step {
  number: string;
  title: string;
  description: string;
  image: string;
}

interface SharedHowItWorksProps {
  title?: string;
  subtitle?: string;
  steps: Step[];
  bgClass?: string;
}

export default function SharedHowItWorks({
  title = 'How It Works',
  subtitle = 'From ding to done in under 15 minutes. Back in the water the same session.',
  steps,
  bgClass = 'bg-white',
}: SharedHowItWorksProps) {
  return (
    <section id="how-it-works" className={`py-24 ${bgClass}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Simple Process</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900">
            {title.split(' ').slice(0, -1).join(' ')}{' '}
            <span className="text-[#0B5C4D]">{title.split(' ').slice(-1)}</span>
          </h2>
          {subtitle && (
            <p className="text-stone-500 text-lg mt-4 max-w-xl mx-auto">{subtitle}</p>
          )}
        </div>

        {/* Desktop timeline */}
        <div className="hidden lg:block relative">
          <div className="absolute top-[52px] left-0 right-0 h-0.5 bg-gradient-to-r from-[#0B5C4D]/10 via-[#0B5C4D]/60 to-[#0B5C4D]/10 mx-16" />
          <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}>
            {steps.map((step, idx) => (
              <div key={step.number} className={`flex flex-col items-center ${idx === Math.floor(steps.length / 2) ? '-mt-3' : ''}`}>
                <div className="relative z-10 w-[52px] h-[52px] rounded-full border-4 border-[#0B5C4D] bg-white flex items-center justify-center mb-5 flex-shrink-0">
                  <span className="text-[#0B5C4D] font-black text-sm">{step.number}</span>
                </div>
                <div className="w-full h-36 rounded-xl overflow-hidden mb-4">
                  <img src={step.image} alt={step.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="text-center px-1">
                  <h3 className="text-stone-900 font-bold text-sm mb-1.5">{step.title}</h3>
                  <p className="text-stone-500 text-xs leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile steps */}
        <div className="lg:hidden space-y-6">
          {steps.map((step) => (
            <div key={step.number} className="flex gap-5 items-start">
              <div className="w-12 h-12 rounded-full border-4 border-[#0B5C4D] bg-white flex items-center justify-center flex-shrink-0">
                <span className="text-[#0B5C4D] font-black text-sm">{step.number}</span>
              </div>
              <div className="flex-1">
                <div className="w-full h-36 rounded-xl overflow-hidden mb-3">
                  <img src={step.image} alt={step.title} className="w-full h-full object-cover object-top" />
                </div>
                <h3 className="text-stone-900 font-bold text-base mb-1">{step.title}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
